import styled from 'styled-components';
export const KeyboardKey = styled.span `
  width: 30px;
  height: 30px;
  align-items: center;
  display: inline-flex;
  justify-content: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 5px;
`;
